// src/AnA/AuthRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import "../Styles/loading.css";

const AuthRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isMember, setIsMember] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const db = getFirestore();
        // Direct document access by UID instead of querying by email
        const userRef = doc(db, "users", user.uid);
        const userSnapshot = await getDoc(userRef);

        if (userSnapshot.exists()) {
          const userData = userSnapshot.data();
          
          // Check if user is a member
          if (userData.role === "member") {
            // Check if subscription is still valid
            if (userData.subscriptionEnd) {
              // Handle Firestore Timestamp properly
              let subscriptionEndDate;
              
              // Check if it's a Firestore Timestamp object
              if (userData.subscriptionEnd && typeof userData.subscriptionEnd.toDate === 'function') {
                subscriptionEndDate = userData.subscriptionEnd.toDate();
              } else {
                // If it's already a Date object or a string
                subscriptionEndDate = new Date(userData.subscriptionEnd);
              }
              
              const now = new Date();
              
              if (subscriptionEndDate > now) {
                setIsMember(true);
              } else {
                setIsMember(false);
              }
            } else {
              // If no subscription end date, assume they are a member
              setIsMember(true);
            }
          } else {
            setIsMember(false);
          }
        } else {
          setIsMember(false);
        }
      } else {
        setIsMember(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="loading-container">Checking subscription...</div>;
  }

  return isMember ? children : <Navigate to="/login" />;
};

export default AuthRoute;
